<div class="customer-stats-and-reports">
  <h3>Customers</h3>
  <br />
  <div class="content">
    <div>
      <div>Current active:</div>
      <div>{{ customerStats?.totalCount }}</div>
    </div>
    <div>
      <div>Current active with active announcements:</div>
      <div>{{ customerStats?.countWithAnnouncements }}</div>
    </div>
    <div>
      <div>Current active with DB product:</div>
      <div>{{ customerStats?.countWithDbProduct }}</div>
    </div>
    <div>
      <div>Current active with Slider product:</div>
      <div>{{ customerStats?.countWithSliderProduct }}</div>
    </div>
    <div>
      <div>Current active with Cv Box product:</div>
      <div>{{ customerStats?.countWithCvBoxProduct }}</div>
    </div>
  </div>
  <br />
  <div>
    <div>Reports:</div>
  </div>
</div>
